import styled, { css } from 'styled-components';

import { breadcrumbConsts } from './Breadcrumb.consts';
import { BreadcrumbIconPosition, IBreadcrumbProps } from './Breadcrumb.types';

type BreadcrumbItemProps = {
  iconPosition: BreadcrumbIconPosition;
};

const BreadcrumbWrapper = styled.ul<Required<Pick<IBreadcrumbProps, 'size'>>>`
  ${({ size, theme }) => css`
    ${size === 'small' && theme.label.small.normal}
    ${size === 'medium' && theme.label.medium.normal}

    color: ${theme.text.onSurface.strong};
    margin: ${breadcrumbConsts[size].margin};
  `}

  list-style: none;
  display: flex;
  padding: 0;
`;

const Breadcrumb = styled.li<Required<Pick<IBreadcrumbProps, 'size'>>>`
  ${({ theme, size }) => css`
    display: flex;
    align-items: center;

    span {
      cursor: default;
    }

    > span,
    > div > span {
      margin-bottom: 1px;
    }

    svg {
      width: ${breadcrumbConsts[size].iconSize};
      height: ${breadcrumbConsts[size].iconSize};
      margin: 0 6px;
    }

    a {
      text-decoration: none;
      color: inherit;
      border-bottom: 1px solid transparent;

      &:hover {
        transition: border-bottom-color 0.5s;
        border-color: ${theme.text.onSurface.strong};
      }

      &:focus {
        outline-color: ${theme.focus.medium};
      }
    }
  `}
`;

const BreadcrumbItem = styled.a<BreadcrumbItemProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${({ iconPosition }) => (iconPosition === 'left' ? 'row' : 'row-reverse')};

  &:focus {
    outline-offset: 3px;
  }
`;

const DropdownContent = styled.span`
  display: flex;
  align-items: center;

  svg {
    margin-right: 0;
  }
`;

export { BreadcrumbWrapper, Breadcrumb, BreadcrumbItem, DropdownContent };
